export type TrackedRefCountable = {
    addRef(debugId: string): void
    release(debugId: string): void
}

export class TrackedRefCountableBase implements TrackedRefCountable {
    constructor(args?: {addRefFn?: () => void; releaseFn?: () => void; disposeFn?: () => void}) {
        this._addRefFn = args?.addRefFn
        this._releaseFn = args?.releaseFn
        this._disposeFn = args?.disposeFn
        this._refCountsByDebugId.set(REF_COUNT_DEBUG_ID_INITIAL, 1)
    }

    get refCount(): number {
        return this._refCount
    }

    get refCountsByDebugId(): ReadonlyMap<string, number> {
        return this._refCountsByDebugId
    }

    addRef(debugId: string) {
        if (this._refCount === 0) {
            throw new Error("RefCountableBase: addRef() called on object with refCount 0")
        }

        ++this._refCount
        const count = this._refCountsByDebugId.get(debugId) ?? 0
        this._refCountsByDebugId.set(debugId, count + 1)

        this._addRefFn?.()
    }

    release(debugId: string) {
        if (this._refCount === 0) {
            throw new Error("RefCountableBase: release() called on object with refCount 0")
        }

        --this._refCount
        const count = this._refCountsByDebugId.get(debugId)
        if (count == null || count === 0) {
            throw new Error(`RefCountableBase: release() called with debugId "${debugId}" that was not found in ref counts map`)
        } else if (count === 1) {
            this._refCountsByDebugId.delete(debugId)
        } else {
            this._refCountsByDebugId.set(debugId, count - 1)
        }

        this._releaseFn?.()
        if (this._refCount === 0) {
            this._disposeFn?.()
        }
    }

    private _refCount = 1
    private readonly _addRefFn?: () => void
    private readonly _releaseFn?: () => void
    private readonly _disposeFn?: () => void
    private readonly _refCountsByDebugId = new Map<string, number>()
}

// export class Ref<T extends object> extends TrackedRefCountableBase {
//     constructor(ref: T, disposeFn?: (ref: T) => void) {
//         super({
//             disposeFn: disposeFn ? () => disposeFn(ref) : undefined,
//         })
//         this._ref = ref
//     }
//
//     get ref(): T {
//         if (this.refCount <= 0) {
//             throw new Error("Ref is disposed")
//         }
//         return this._ref
//     }
//
//     private _ref: T
// }

export const REF_COUNT_DEBUG_ID_INITIAL = "initial"
